module.exports = __webpack_public_path__ + "img/gb805.prt.24a62acb.jpg";